import { Easing, Tween } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import AnimationClip from '../AnimationClip';
import Renderable from '../../../Component/Renderable';
import ElementComponent from '../../../Component/UI/Element';
import { AwaitIterators } from '../AnimationHelper';

export class SuitcaseTutorialClose extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const item = gameObject.find('ftux/unlocked_item');
        const text = gameObject.find('ftux/unlocked_text');
        const btnContinue = gameObject.find('ftux/continue_button');
        const shine = gameObject.find('ftux/shine');
        const bottomContainer = gameObject.find('bottom_container');
        const suitcase = gameObject.find(
            'bottom_container/suitcase_close_button'
        );
        const tapMe = gameObject.find(
            'bottom_container/suitcase_close_button/tap_me'
        );

        text.getComponent(Renderable).visible = false;
        btnContinue.getComponent(Renderable).visible = false;
        shine.getComponent(Renderable).visible = false;

        const itemElem = item.getComponent(ElementComponent);
        const suitcaseElement = suitcase.getComponent(ElementComponent);

        const itemAnchorsTween = this.getTween(itemElem.layout.anchors);
        itemAnchorsTween
            .to({ 0: 1, 1: 1, 2: 1, 3: 1 }, 500)
            .easing(Easing.Cubic.InOut);

        const itemOffsetsTween = this.getTween(itemElem.layout.offsets);
        itemOffsetsTween
            .to({ 0: 125, 1: 110, 2: 125, 3: 110 }, 500)
            .easing(Easing.Cubic.InOut);

        const itemScaleTween = this.getTween(itemElem.layout.scale);
        itemScaleTween.to({ 0: 1, 1: 1 }, 500).easing(Easing.Cubic.InOut);

        yield* AwaitIterators([
            this.startTween(itemAnchorsTween),
            this.startTween(itemOffsetsTween),
            this.startTween(itemScaleTween),
        ]);

        item.getComponent(Renderable).visible = false;
        bottomContainer.getComponent(Renderable).visible = true;

        const suitcaseTween: Tween = this.getTween(suitcaseElement.layout);
        suitcaseTween.to({ angle: -10 }, 50);

        yield* this.startTween(suitcaseTween);

        suitcaseTween.to({ angle: 10 }, 100);

        yield* this.startTween(suitcaseTween);

        suitcaseTween.to({ angle: 0 }, 50);

        yield* this.startTween(suitcaseTween);

        tapMe.getComponent(Renderable).visible = true;
    }
}
